import { render } from "./Service.vue?vue&type=template&id=4e10d6d2"
const script = {}

import exportComponent from "E:\\project2\\skin-web\\破阵勇士\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__